import { svg } from "lit";
const icon = svg `<path d="M22.8654 38.9999V13.3153L10.6 25.5807L9 24L23.9999 9L38.9999 24L37.3999 25.5807L25.1346 13.3153V38.9999H22.8654Z" fill="currentColor"/>`;
export default icon;
